// import danielKushnir from "../assets/images/events/daniel_kushnir.avif";
// import pioneerJazz from "../assets/images/events/pioneer-jazz.avif";
// import hiredGunn from "../assets/images/events/hired_gunn.avif";

import avalonRevival from "../assets/Events_Pics_20260518/AvalonRevival_June13.jpg";
import nathanIgnacio from "../assets/Events_Pics_20260518/NathanIgnacio_June16.png";
import cynthiaRenee from "../assets/Events_Pics_20260518/CynthiaRenee_June20.jpg";
import donnyWayrads from "../assets/Events_Pics_20260518/Donny&TheWayrads_June27.jpg";
import dunsbarRoad from "../assets/Events_Pics_20260518/DunsbarRoad_July11.jpg";
import tomRigney from "../assets/Events_Pics_20260518/TomRigney_July18.jpg";
import network from "../assets/Events_Pics_20260518/Network_July25.jpg";
import geoffreyMiller from "../assets/Events_Pics_20260518/GeoffreyMiller_August1.jpg";
// import sugarHigh from "../assets/Events_Pics_20260518/SugarHigh_August8.jpg";
import groovyJudy from "../assets/Events_Pics_20260518/GroovyJudy_August15.jpg";
// import billyWalsh from "../assets/Events_Pics_20260518/BillyWalsh_August22.jpg";
import fabulousOffBrothers from "../assets/Events_Pics_20260518/TheFabulousOffBrothers_August29.jpg";
import gregSutton from "../assets/Events_Pics_20260518/GregSuttonFriends_Aug29.jpg";
import skyKings from "../assets/Events_Pics_20260518/TheSkyKings_September5.jpg";

// export const eventsData = {
//   "daniel-kushnir": {
//     id: "daniel-kushnir",
//     title: "JULY 9 | DANIEL KUSHNIR",
//     image: danielKushnir,
//     description: "Taco Tuesday x Daniel Kushnir",
//     subdescription: `Join us for our Taco Tuesday event, featuring delicious tacos and a live performance by the talented Daniel Kushnir! Bring your friends and family for a midweek fiesta you won't want to miss!`,
//   },
//   "pioneer-jazz": {
//     id: "pioneer-jazz",
//     title: "JULY 11 | PIONEER JAZZ",
//     image: pioneerJazz,
//     description: "Summer Nights Live Music",
//     subdescription:
//       "Join us for a sensational summer evening filled with the captivating sounds of Pioneer Jazz (Joe Bellamy & Jenni Roland)!",
//   },
//   "hired-gunn": {
//     id: "hired-gunn",
//     title: "JULY 13 | HIRED GUNN",
//     image: hiredGunn,
//     description: "Summer Nights Live Music",
//     subdescription:
//       "Join us on Saturday, July 13th, at 6 PM for an amazing live band performance at The Bistro. Enjoy great tunes, delicious food, and a fantastic atmosphere. Gather your friends and family for a night to remember!",
//   },
// };

export const eventsData = [
  {
    id: "2026-06-13-avalon-revival",
    title: "Avalon Revival",
    genre: "Decades of Rock",
    date: "June 13, Saturday",
    time: "6–9 PM",
    image: avalonRevival,
  },
  {
    id: "2026-06-16-nathan-ignacio",
    title: "Nathan Ignacio",
    date: "June 16, Tuesday",
    time: "6–9 PM",
    image: nathanIgnacio,
  },
  {
    id: "2026-06-20-cynthia-renee",
    title: "Cynthia Renee",
    genre: "Country",
    date: "June 20, Saturday",
    time: "6–9 PM",
    image: cynthiaRenee,
  },
  {
    id: "2026-06-27-donny-wayrads",
    title: "Donny & The Wayrads",
    genre: "Classic Rock Hits",
    date: "June 27, Saturday",
    time: "6–9 PM",
    image: donnyWayrads,
  },
  {
    id: "2026-08-08-dunsbar-road",
    title: "Dunsbar Road's My Favorite Mistake",
    genre: "Tribute to Sheryl Crow",
    date: "August 8, Saturday",
    time: "6–9 PM",
    image: dunsbarRoad,
  },
  {
    id: "2026-07-18-tom-rigney",
    title: "Tom Rigney & Flambeau",
    genre: "Cajun Zydeco Violin",
    date: "July 18, Saturday",
    time: "6–9 PM",
    image: tomRigney,
  },
  {
    id: "2026-07-25-network",
    title: "Network",
    genre: "Classic Rock, R&B, Funk",
    date: "July 25, Saturday",
    time: "6–9 PM",
    image: network,
  },
  {
    id: "2026-08-01-geoffrey-miller",
    title: "Geoffrey Miller",
    genre: "Country Rockabilly",
    date: "August 1, Saturday",
    time: "6–9 PM",
    image: geoffreyMiller,
  },
  // {
  //   id: "2026-08-08-sugar-high",
  //   title: "Sugar High",
  //   genre: "90's R&B, Funky, Soulful",
  //   date: "August 8, Saturday",
  //   time: "6–9 PM",
  //   image: sugarHigh,
  // },
  {
    id: "2026-08-15-groovy-judy",
    title: "Groovy Judy",
    genre: "Hendrix Influenced Rock, Funk & Soul",
    date: "August 15, Saturday",
    time: "6–9 PM",
    image: groovyJudy,
  },
  // {
  //   id: "2026-08-22-billy-walsh",
  //   title: "Billy J. Walsh & Friends",
  //   genre: "Classic Rock from the 60's through 90's",
  //   date: "August 22, Saturday",
  //   time: "6–9 PM",
  //   image: billyWalsh,
  // },

  {
    id: "2026-08-29-greg-sutton-friends",
    title: "Greg Sutton & Friends",
    genre: "Rock, Blues, Americana",
    date: "August 29, Saturday",
    time: "6–9 PM",
    image: gregSutton,
  },
  {
    id: "2026-09-05-sky-kings",
    title: "The Sky Kings",
    genre: "Country Americana",
    date: "September 5, Saturday",
    time: "6–9 PM",
    image: skyKings,
  },
  {
    id: "2026-09-22-fabulous-off-brothers",
    title: "The Fabulous Off Brothers",
    genre: "Classic Rock from the 60's – 90's",
    date: "September 12, Saturday",
    time: "6–9 PM",
    image: fabulousOffBrothers,
  },
];
